export default {
  types: {
    subscribe: '订阅号',
    service: '服务号',
    mini: '小程序',
    enterprise: '企业微信'
  },
  usages: {
    point_change: '积分变更提醒',
    expire_client: '会员过期提醒',
    level_change: '等级变更提醒'
  }
}


// WEBPACK FOOTER //
// ./src/store/config/wechat.js